import React, { Component } from 'react';
import {
  withRouter
} from "react-router-dom";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import logo from '../../images/logo.png';
import banner from '../../images/banner.jpeg';

// import MenuIcon from '@material-ui/icons/Menu';

import { getComm, getNewsCat, RES_BASE_URL } from '../../redux/action';

import { getValue, getLocalLocale } from "../../constant/Locale";
import MenuIcon from '@material-ui/icons/Menu';

import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faCoffee } from "@fortawesome/fontawesome-free-solid";

import './Header.css'; 

import { IconName } from "react-icons/fa";

class Header extends Component {

	constructor(props, context) {
	    super(props, context);
	    this.state = {
	      
	    };
	  }

  	componentWillMount() {

	
  	}

	componentDidMount() {
	
	}

	render() {
		
		return (
		<div>
			<div className="topBanner">

				<div className="banner">
					<h1>Never Stop Learning... <br /> Because Life Never Stops Teaching.</h1>
					{/*<img className="logo" src={logo}  />*/}
				</div>


				
				
			</div>
	    </div>

		);
	}

}

const mapStateToProps = (state) => {
  return {
    // error: getMembershipError(state.membershipReducer),
    // pending: getMembershipPending(state.membershipReducer),
    // registerSuccess: getMembershipRegisterStatus(state.membershipReducer),
    // userInfo: getMembershipUserInfo(state.membershipReducer),
    // changePwSuccess:  getChangePasswordSuccess(state.membershipReducer),
    // verifyEmailSuccess: getVerifyEmailSuccess(state.membershipReducer)
    // content_verison: getBibleContentVersion(state.bibleBookReducer),
    // secondary_content_verison: getBibleSecondaryContentVersion(state.bibleBookReducer)
  };
}

const mapDispatchToProps = dispatch => bindActionCreators({
  // register: registerAction,
  // login: loginAction,
  // logout: logoutAction,
  // changePw: changePwAction,
  // changeInfo: changeInfoAction,
  // sendForgetPwEmail: sendForgetPwEmailAction,
  // verifyEmail: verifyEmailAction
}, dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Header));